import { formatDateToObject } from '../../../../utils/format_time';
import * as moment from 'moment-timezone';
import { BUDGET_REFRESH_INTERVAL } from '../../../MealBudgets/modals/budget_helper';
import { ExpenseCodeEnforcementMode, PermittedOrderContents, } from '../../../MealBudgets/types/budgets';
export var createImmediateOneTimeBudget = function (_a) {
    var name = _a.name, teamAccountId = _a.teamAccountId, budgetAmountInCents = _a.budgetAmountInCents, groupIds = _a.groupIds, expireDaysInSeconds = _a.expireDaysInSeconds;
    var timeNowInMillis = new Date(Date.now()).getTime();
    var timeNowInSeconds = Math.floor(timeNowInMillis / 1000);
    var todayAsDateObject = formatDateToObject(moment());
    var expirationAsDateObject = formatDateToObject(moment().add(expireDaysInSeconds, 'seconds'));
    return {
        name: name,
        teamAccountId: teamAccountId,
        addressId: 0,
        daysList: [1, 2, 3, 4, 5, 6, 7],
        startTime: {
            // all time
            hours: 0,
            minutes: 0,
        },
        endTime: {
            // all time
            hours: 23,
            minutes: 59,
        },
        unitAmount: budgetAmountInCents,
        refreshInterval: BUDGET_REFRESH_INTERVAL.OneTime,
        activeAtTimestamp: {
            seconds: timeNowInSeconds,
        },
        inactiveAtTimestamp: {
            seconds: timeNowInSeconds + expireDaysInSeconds,
        },
        activeAtDate: todayAsDateObject,
        inactiveAtDate: expirationAsDateObject,
        groupIds: groupIds,
        expenseCodeConfig: {
            expenseCodeEnforcementMode: ExpenseCodeEnforcementMode.OPTIONAL_CODE,
            expenseCodeValidValuesList: [],
        },
        budgetConfig: {
            permittedOrderContentsList: [
                PermittedOrderContents.WORK_ORDER_CONTENT_RESTAURANT,
            ],
        },
    };
};
